import React from "react";
import PropTypes from "prop-types";

const Controls = ({ crud, id, title, isChild, childItemValues, singularItemName = "" }) => {
	const { createChildItem, deleteItem, duplicateItem, editItem } = crud;

	// console.log('props', props)

	const fireAction = (e, type) => {
		e.preventDefault();
		switch (type) {
			case "CREATECHILDITEM":
				createChildItem(id, childItemValues);
				break;
			case "EDIT":
				editItem(id);
				break;
			case "DUPLICATE":
				duplicateItem(id);
				break;
			case "DELETE":
				deleteItem(id, title);
				break;
			default:
				break;
		}
	};

	if (singularItemName) {
		singularItemName = " " + singularItemName;
	}

	return (
		<div className="controls">
			{crud && editItem && (
				<button title={`Edit${singularItemName}`} onClick={e => fireAction(e, "EDIT")}>
					<i className="fal fa-edit"> </i>
				</button>
			)}
			{crud && createChildItem && !isChild && (
				<button title={`Add a Child${singularItemName}`} onClick={e => fireAction(e, "CREATECHILDITEM")}>
					<i className="fal fa-layer-plus"> </i>
				</button>
			)}
			{crud && editItem && (
				<button title={`Duplicate${singularItemName}`} onClick={e => fireAction(e, "DUPLICATE")}>
					<i className="fal fa-clone"></i>
				</button>
			)}
			{crud && deleteItem && (
				<button title={`Delete${singularItemName}`} onClick={e => fireAction(e, "DELETE")}>
					<i className="fal fa-trash"></i>
				</button>
			)}
		</div>
	);
};

Controls.propTypes = {
	crud: PropTypes.object.isRequired,
	childItemValues: PropTypes.object,
	id: PropTypes.string.isRequired,
	isChild: PropTypes.bool,
	singularItemName: PropTypes.string,
	title: PropTypes.string.isRequired,
};

export default Controls;
